import { useEffect } from 'react';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import Routes from 'ContentUtils/Routes';
const cancelIdleCallback = window.cancelIdleCallback || clearTimeout;
const requestIdleCallback = window.requestIdleCallback || (cb => setTimeout(cb, 1));

/**
 * Email template paths that may be converted to DND templates in the future.
 * @see https://private.hubteam.com/config/com.hubspot.cosemail/COSEmailCommonConfig/EMAIL_CLASSIC_TO_DND_CLASSIC_PLAIN_TEXT_TEMPLATE_PATHS/STRING_SET
 */
const UNSAFE_TEMPLATE_PATHS = [/generated_layouts\/(\d+).html/, '@hubspot/email/custom/simple_follow_up_email.html', '/plain_email.html', 'custom/email/default/optin.html', 'custom/email/default/plain_email_coded.html', 'custom/email/lead_flows/simple_follow_up_email.html', 'custom/email/responsive/plain_email.html', 'email/coded_templates/plain_text_email.html', 'email/plain_text_email.html'];
export function getCacheKey(id) {
  return `MARKETING_EMAIL:${PortalIdParser.get()}:EARLY_PREVIEW:${id}`;
}
function getIsUngatedForLongLivedCachedEarlyPreview() {
  try {
    const {
      gates
    } = userInfoSync();
    return gates.includes(gate('Email:LongLivedCachedEarlyPreview'));
  } catch (_unused) {
    return false;
  }
}
export function trySetEarlyPreviewCacheValue({
  emailTemplateMode,
  id,
  previewDomain: maybePreviewDomain,
  previewKey,
  templatePath,
  versionIdBeforeDndConversion
}, storage = localStorage) {
  const previewDomainPromise = maybePreviewDomain ? Promise.resolve({
    previewDomain: maybePreviewDomain
  }) : Routes.previewDomainPromise;
  if (!previewDomainPromise) {
    return;
  }
  const getCacheTerm = () => {
    if (!templatePath || typeof versionIdBeforeDndConversion === 'number' || UNSAFE_TEMPLATE_PATHS.find(path => templatePath.match(path))) {
      return 'SHORT_LIVED';
    }
    return 'LONG_LIVED';
  };
  previewDomainPromise.then(({
    previewDomain
  }) => {
    const key = getCacheKey(id);
    const value = {
      cacheTerm: getCacheTerm(),
      emailTemplateMode,
      isUngatedForLongLivedCachedEarlyPreview: getIsUngatedForLongLivedCachedEarlyPreview(),
      previewDomain,
      previewKey,
      timestamp: Date.now()
    };
    storage.setItem(key, JSON.stringify(value));
  }).catch(() => {
    // ignore
  });
}
export function useSetupEarlyPreviewCache() {
  useEffect(() => {
    const callbackId = requestIdleCallback(() => {
      void Routes.getPreviewDomainPromise();
    });
    return () => cancelIdleCallback(callbackId);
  }, []);
}
export function useEarlyPreviewCache() {
  useSetupEarlyPreviewCache();
  return {
    getCacheKey,
    getPreviewDomain: Routes.getPreviewDomainPromise,
    setEarlyPreviewCacheValue: trySetEarlyPreviewCacheValue
  };
}
export default useEarlyPreviewCache;